import type { FC } from 'react';
import { z } from 'zod';

import { FullPageContent } from '@/components/layout/full-page-content';
import { Dashboard } from '@/components/looker/dashboard';
import { codec, useQueryParams } from '@/hooks/router/use-query-params';
import { useCurrentAsset } from '@/hooks/use-current-asset';

// TODO: remove?
export const WarrantyPageLegacy: FC = () => {
  const { asset, assetId, isMobility } = useCurrentAsset();

  const [filters] = useQueryParams({
    group_id: {
      key: 'group_id',
      schema: z.string().optional().default(''),
      codec: codec.string,
    },
    top_id: {
      key: 'top_id',
      schema: z.string().optional().default(''),
      codec: codec.string,
    },
    unit_id: {
      key: 'unit_id',
      schema: z.string().optional().default(''),
      codec: codec.string,
    },
  });

  if (isMobility && filters.top_id === '') {
    filters.top_id = assetId;
  } else if (!isMobility && filters.group_id === '') {
    // For BESS cases, we use the site ID as the group_id
    filters.group_id = asset?.fullFrontendId ?? '';
  }

  return (
    <FullPageContent>
      <Dashboard key={asset?.id} id="warranty" filters={filters} />
    </FullPageContent>
  );
};
